import { useList } from "@refinedev/core";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/forms/PageHeader";
import { MoneyDisplay } from "@/components/forms/MoneyDisplay";
import { formatDate } from "@/lib/formatters";

export function PagosListPage() {
  const { data, isLoading } = useList({
    resource: "pagos_tienda",
    sorters: [{ field: "fecha_transferencia", order: "desc" }],
    meta: { select: "*, periodos_cobro(numero_correlativo, tiendas(nombre))" },
  });

  return (
    <div>
      <PageHeader
        title="Pagos a tiendas"
        actions={
          <Link to="/pagos/nuevo" className="btn-primary inline-flex items-center gap-2">
            <Plus className="size-4" /> Nuevo pago
          </Link>
        }
      />
      {isLoading ? (
        <div className="card p-8 text-center text-fg-muted">Cargando...</div>
      ) : (
        <ul className="space-y-2">
          {data?.data.map((p) => {
            const periodo = p.periodos_cobro as {
              numero_correlativo: number;
              tiendas: { nombre: string };
            };
            return (
              <li key={p.id as string} className="card p-4 flex items-center gap-3">
                <div className="flex-1">
                  <p className="font-medium">
                    Corte #{periodo?.numero_correlativo} · {periodo?.tiendas?.nombre}
                  </p>
                  <p className="text-sm text-fg-muted">
                    {formatDate(p.fecha_transferencia as string)}
                    {p.numero_referencia_banco ? ` · Ref ${p.numero_referencia_banco}` : ""}
                  </p>
                </div>
                <MoneyDisplay value={p.valor_transferido as number} className="font-medium" />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
